/**
 * Created by Jan on 16.09.2017.
 */

(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Tables = Lfl.Tables || {};

    (function (Tables, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.Tables, 'DatatablesWidthRefresher')) {
            return;
        }

        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */

        /**
         * Refreshes the table columns width which was not calculated properly.
         *
         * This happens for hidden tabs and for freshly displayed datatables with hidden columns.
         *
         * @memberOf Lfl.Tables
         */
        Lfl.Tables.DatatablesWidthRefresher = Tables.DatatablesWidthRefresher || {};

        (function (DatatablesWidthRefresher, $, undefined) {
            /*
             |==========================================================================================================
             | Object definition
             |==========================================================================================================
             */

            /*
             |----------------------------------------------------------------------------------------------------------
             | Public methods
             |----------------------------------------------------------------------------------------------------------
             */

            /**
             * Refreshes the width of an initialized datatable.
             *
             * @memberOf Lfl.Tables.DatatablesWidthRefresher
             * @param {string | object} tableApiOrPath
             */
            DatatablesWidthRefresher.refreshWidth = function (tableApiOrPath) {
                if (typeof tableApiOrPath === 'string') {
                    DatatablesWidthRefresher.refreshWidthByPath(tableApiOrPath);
                    return;
                }

                if (typeof tableApiOrPath === 'object') {
                    DatatablesWidthRefresher.refreshWidthByApi(tableApiOrPath);
                    return;
                }

                var type = typeof tableApiOrPath;
                throw new Error("Invalid parameter type: " + type + ". Whole variable: " + tableApiOrPath);
            };

            /**
             * Refreshes the width of an initialized datatable.
             * @memberOf Lfl.Tables.DatatablesWidthRefresher
             * @param {string} tablePath
             */
            DatatablesWidthRefresher.refreshWidthByPath = function (tablePath) {
               var tableResolver = new Lfl.Tables.DatatableResolver(tablePath);

                DatatablesWidthRefresher.refreshWidthByApi(tableResolver.getApi());
            };

            /**
             * Refreshes the width of an initialized datatable.
             *
             * Link: DataTables::FitOnSmallDisplays::ColumnResizing::ResetColWidth
             *
             * @memberOf Lfl.Tables.DatatablesWidthRefresher
             * @param {object} table
             */
            DatatablesWidthRefresher.refreshWidthByApi = function (table) {
                if(! (table instanceof $.fn.dataTable.Api)) {
                    throw new Error ("Received an object that is not an instance of datatables.");
                }

                table.columns.adjust().draw();

                if (typeof table.table !== 'undefined' &&
                    typeof table.table().node() !== 'undefined') {
                    table.table().node().style.width = '';
                }
            };


            /*
             |----------------------------------------------------------------------------------------------------------
             | Private methods
             |----------------------------------------------------------------------------------------------------------
             */
        }(Tables.DatatablesWidthRefresher, jQuery));
    }(Lfl.Tables, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));